import ProductDescription from './ProductDescription'

const WWPitaBreadProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '012',
  IsBroadband: true,
  Size: '',
  WholeWheatCert: false,
}

export default WWPitaBreadProduct
